import { NgModule } from '@angular/core';
import { VirtualHomeComponent } from './virtual-home/virtual-home';
import { IonicPageModule } from 'ionic-angular';
import { SharedModule } from '../shared/shared.module';
import { EventListingComponent } from './event-listing/event-listing';
import { MarketListingComponent } from './market-listing/market-listing';
import { StarRatingComponent } from './star-rating/star';
import { LeaguestListingComponent } from './leagues-listing/leagues-listing';
import { SportsListingComponent } from './sports-listing/sports-listing';
import { VirtualGameComponent } from './virtual-game/virtual-game';
import { BaselineSharedModule } from 'baseline-lib';
import { VirtualBetslipPageModule } from './virtual-bet-slip/virtual-betslip.module';

@NgModule({
  declarations: [
    VirtualHomeComponent,
    VirtualGameComponent,
    EventListingComponent,
    MarketListingComponent,
    StarRatingComponent,
    SportsListingComponent,
    LeaguestListingComponent
  ],
  imports: [
    SharedModule,
    BaselineSharedModule,
    VirtualBetslipPageModule,
    IonicPageModule.forChild(VirtualSportsModule),
  ],
  exports: [
    VirtualHomeComponent,
    VirtualGameComponent    
  ]
})
export class VirtualSportsModule { }



// WEBPACK FOOTER //
// ./src/app/virtual-sports/virtual-sports.module.ts